import { Component } from '@angular/core';
import { UserService } from 'services';

/**
 * Just used to navigate component to homepage
 */
@Component({
    template: '',
    selector: "test",
})
export class AppEntryComponent {
    constructor(protected userService: UserService) {
        this.userService.navigateToHomepage(true);
    }
}
